import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist/dist/umd'
import user from './modules/user'
import qiniu from './modules/qiniu'
import searchKey from './modules/searchKey'
import getters from './getters'
import app from './modules/app'

Vue.use(Vuex)

const vuexLocal = new VuexPersist({
  storage: window.localStorage
})

const store = new Vuex.Store({
  modules: {
    app,
    user,
    qiniu,
    searchKey
  },
  getters,
  plugins: [vuexLocal.plugin]
})

export default store
